<ul>
  <li *ngIf="!ContextService.IsUserLoggedIn || (ContextService.IsUserLoggedIn && ContextService.IsJobSeeker)"><a
      routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
      [routerLink]="Navigations.CareerAdvice">Career Advice</a></li>
  <li *ngIf="!ContextService.IsUserLoggedIn || (ContextService.IsUserLoggedIn && ContextService.IsRecruiter)"><a
      routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
      [routerLink]="Navigations.RecruitmentAdvice">Recruitment Advice</a></li>
  <li *ngIf="!ContextService.IsUserLoggedIn || (ContextService.IsUserLoggedIn && ContextService.IsRecruiter)"><a
      routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
      [routerLink]="Navigations.CvSearch">Searching CVs </a></li>
  <li><a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
      routerLink="{{Navigations.UserDirectory}}">User Directory</a></li>
  <li><a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
      routerLink="{{Navigations.CompanyDirectory}}">Company Directory</a></li>
  <li><a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
      routerLink="{{ContextService.IsUserLoggedIn ? Navigations.JoinedGroupsAndForums : Navigations.Forums}}">Groups &
      Forums</a></li>
  <li><a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" [routerLink]="['/blogs']">Blogs</a></li>
</ul>